import { alertSuccess } from "../../utils/feedback";
import axiosInstance from "../../axios/index";
import { translate } from "../../utils/utils";
import {
  SET_ASSETS,
  ADD_ASSET,
  UPDATE_ASSET,
  REMOVE_ASSET,
  SET_USER_ASSETS,
  SET_RISK_ASSETS,
  INFINTIE_ASSETS,
  SET_SEARCHED_ASSET,
  SET_ORGA_ASSETS,
  AVAILABLE_ASSETS,
} from "../types/assetsTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

export const setAssets = (items, totalPages, sources) => ({
  type: SET_ASSETS,
  payload: { items, totalPages, sources },
});

export const setInfiniteAssets = (items, totalPages) => ({
  type: INFINTIE_ASSETS,
  payload: { items, totalPages },
});

export const setSearchedAssets = (items, totalPages) => ({
  type: SET_SEARCHED_ASSET,
  payload: { items, totalPages },
});

export const setUserAssets = (items, totalPages, sources) => ({
  type: SET_USER_ASSETS,
  payload: { items, totalPages, sources },
});
export const addAsset = (item) => ({ type: ADD_ASSET, payload: item });
export const updateAsset = (id, data) => ({
  type: UPDATE_ASSET,
  payload: { id: id, data },
});
export const removeAsset = (id) => ({ type: REMOVE_ASSET, payload: id });

export const setRiskAsset = (items) => ({
  type: SET_RISK_ASSETS,
  payload: items,
});

export const setAvalailableAssets = (items) => ({
  type: AVAILABLE_ASSETS,
  payload: items,
});

// new export

export const setOrgaAssets = (
  businessFunctions,
  orphanedAssets,
  availableCategories
) => ({
  type: SET_ORGA_ASSETS,
  payload: { businessFunctions, orphanedAssets, availableCategories },
});

export const fetchOrgaAssets =
  (orgaId, search = "", category = "", page = 1) =>
  async (dispatch) => {
    dispatch(requestStarted("orga_asset"));
    console.log("Fetching orga assets for orgaId:", orgaId);
    try {
      const params = new URLSearchParams({
        search,
        category,
        page,
      });
      const res = await axiosInstance.get(
        // `/scoring/fetch_asset_discovery_data/${orgaId}?${params.toString()}`
        `/survey/critical_business_functions/${orgaId}?${params.toString()}`
      );

      const {
        business_functions = [],
        orphaned_assets = { assets: [] },
        available_categories = [],
      } = res.data.result;

      dispatch(
        setOrgaAssets(
          business_functions,
          orphaned_assets.assets,
          available_categories
        )
      );
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };

export const fetchUserAssets = (
  page,
  searchText,
  filter,
  accountType,
  organizationId
) => {
  return async (dispatch) => {
    dispatch(requestStarted("asset"));
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.get(
              `/model/user_assets?orga_id=${organizationId}&page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}`
            )
          : await axiosInstance.get(
              `/model/user_assets?page=${page}&search${
                searchText ? "=" + searchText : ""
              }&source${filter !== "all" ? "=" + filter : ""}`
            );
      const items = res.data;
      dispatch(
        setUserAssets(items?.my_assets, items?.total_pages, items?.sources)
      );
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchAllAssets = (
  accountType,
  page,
  searchText,
  filter,
  ids,
  infinite
) => {
  return async (dispatch) => {
    dispatch(requestStarted("asset"));
    try {
      const res = await axiosInstance.get(
        `/model/assets?page=${page}&search${
          searchText ? "=" + searchText : ""
        }&source${filter !== "all" ? "=" + filter : ""}&ids${
          ids ? (ids.length > 0 ? "=" + ids : "=[]") : ""
        }`
      );
      const items = res.data;
      if (ids && !infinite) {
        dispatch(setRiskAsset(items?.assets));
      } else if (!ids && infinite) {
        if (searchText && page === 1) {
          dispatch(setSearchedAssets(items?.assets, items?.total_pages));
        } else {
          dispatch(setInfiniteAssets(items?.assets, items?.total_pages));
        }
      } else {
        dispatch(setAssets(items?.assets, items?.total_pages, items?.sources));
      }
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestCreatingAsset = (
  page,
  searchText,
  filter,
  { assetName, assetDescription, owner, assetValue },
  accountType,
  accountId
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      let data = {
        [translate("title")]: assetName,
        [translate("description")]: assetDescription,
        owner: owner,
        value: Number(assetValue),
      };
      if (accountType === "enterprise") {
        data.related_account_id = accountId;
      }
      const res = await axiosInstance.post(`/model/assets`, data);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(
        addAsset({
          [translate("title")]: assetName,
          [translate("description")]: assetDescription,
          owner: owner,
          value: Number(assetValue),
        })
      );
      dispatch(fetchAllAssets(accountType, page, searchText, filter));

      if (accountType !== "enterprise") {
        dispatch(fetchUserAssets(1, null, "all"));
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestUpdatingAsset = (
  page,
  searchText,
  filter,
  id,
  { assetName, assetDescription, owner, assetValue },
  myAsset,
  accountType,
  accountId,
  role
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      let data = {
        [translate("title")]: assetName,
        [translate("description")]: assetDescription,
        owner: owner,
        value: Number(assetValue),
      };

      if (accountType === "enterprise") {
        data.related_account_id = accountId;
      }
      const res = myAsset
        ? await axiosInstance.put(`model/assets/${id}`, data)
        : await axiosInstance.put(`model/assets/${id}`, {
            owner: owner,
            value: Number(assetValue),
          });
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }

      dispatch(
        updateAsset(id, {
          [translate("title")]: assetName,
          [translate("description")]: assetDescription,
          // owner: owner,
          value: Number(assetValue),
        })
      );
      if (role !== "enterprise_user") {
        dispatch(fetchAllAssets(accountType, page, searchText, filter));
      }
      if (accountType !== "enterprise") {
        dispatch(fetchUserAssets(1, null, "all"));
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDeletingAsset = (
  page,
  searchText,
  filter,
  id,
  accountType,
  accountId
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.delete(
              `model/assets/${id}?related_account_id=${accountId}`
            )
          : await axiosInstance.delete(`model/assets/${id}`);
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(removeAsset(id));
      if (accountType === "enterprise") {
        dispatch(fetchAllAssets(accountType, page, searchText, filter));
      } else {
        dispatch(fetchUserAssets(1, null, "all"));
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestAssignAssetToOrganization = (
  page,
  searchText,
  filter,
  id,
  organizations,
  accountType
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/model/affect_asset/${id}`, {
        orga_ids: organizations,
      });
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(fetchAllAssets(accountType, page, searchText, filter));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestUpdateUserAssetValue = (
  page,
  searchText,
  filter,
  id,
  value,
  orgaId,
  accountType,
  role
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      const res =
        role === "enterprise_user"
          ? await axiosInstance.put(`/model/user_asset/${id}`, {
              value: value,
            })
          : await axiosInstance.put(
              `/model/user_asset/${id}?orga_id=${orgaId}`,
              {
                value: value,
              }
            );
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(fetchUserAssets(page, searchText, filter, accountType, orgaId));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDeletingUserAsset = (
  page,
  searchText,
  filter,
  id,
  orgaId,
  accountType
) => {
  return async (dispatch, getState) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.delete(
        `/model/user_asset/${id}?orga_id=${orgaId}`
      );
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(fetchUserAssets(page, searchText, filter, accountType, orgaId));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export function editOrgaAsset(orgaId, data) {
  return async (dispatch) => {
    dispatch(requestStarted("orga_asset"));
    try {
      const res = await axiosInstance.put(
        `/survey/edit_draft_version/${orgaId}`,
        data
      );
      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }
      // re-fetch the organisation assets for the orgaId that was edited
      dispatch(fetchOrgaAssets(orgaId));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
}

export function getAvailableAssets(orgaId, bf_name, bf_type) {
  return async (dispatch) => {
    dispatch(requestStarted("available_asset"));
    try {
      const res = await axiosInstance.get(
        `/survey/available_assets/${orgaId}?type=${bf_type}&bf_name=${bf_name}`
      );
      // server returns an object that contains available_assets array
      const available = res?.data?.available_assets ?? [];
      dispatch(setAvalailableAssets(available));
      dispatch(requestSucceeded(res.data));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
      return [];
    }
  };
}
